"use client";

import React from "react";
import { MapPin, Clock, Phone, Mail } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurRegion() {
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="80760" id="onze-locatie" className="relative w-full h-[500px] md:h-[600px] bg-background dark overflow-hidden" aria-label="Kaart van onze kantoorlocatie">
      <div className="absolute inset-0" style={{
      backgroundImage: "url('https://connectedonline.nl/wp-content/uploads/2026/04/d13d34009fd12cefdb248695a50245d5.jpg')",
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundAttachment: "scroll"
    }}></div>

      <div className="absolute inset-0 bg-background/40 mix-blend-multiply"></div>

      <div className="absolute inset-0 flex items-end md:items-center justify-center md:justify-start p-4 md:p-8 lg:p-16 xl:p-24 pointer-events-none pb-8 md:pb-8">
        <div ref={cardRef} className={`w-full max-w-md pointer-events-auto transition-all duration-1000 ease-out transform ${isCardVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          <Card className="bg-card/80 backdrop-blur-2xl border-border/40 shadow-2xl shadow-black/40">
            <CardHeader className="pb-4">
              <CardTitle className="text-2xl md:text-3xl font-default font-bold text-foreground tracking-tight">De Connected Hub</CardTitle>
              <CardDescription className="text-base font-default text-muted-foreground leading-relaxed">Vanuit heel Nederland verbinden wij ondernemers met de online groei die zij verdienen</CardDescription>
            </CardHeader>
            <CardContent className="space-y-5">
              <div className="flex items-start gap-4">
                <div className="bg-primary/20 p-2 rounded-full shrink-0 mt-0.5 border border-primary/30">
                  <MapPin className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="font-default font-semibold text-foreground">Locatie</p>
                  <p className="text-muted-foreground font-default text-sm leading-relaxed">Haarlemmermeer based, overal online</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/20 p-2 rounded-full shrink-0 mt-0.5 border border-primary/30">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="font-default font-semibold text-foreground">Beschikbaarheid</p>
                  <p className="text-muted-foreground font-default text-sm leading-relaxed">Flexibel beschikbaar</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/20 p-2 rounded-full shrink-0 mt-0.5 border border-primary/30">
                  <Phone className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="font-default font-semibold text-foreground">Direct Contact</p>
                  <p className="text-muted-foreground font-default text-sm leading-relaxed">+31 (6) 40 25 51 26</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-primary/20 p-2 rounded-full shrink-0 mt-0.5 border border-primary/30">
                  <Mail className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="font-default font-semibold text-foreground">E-mail</p>
                  <p className="text-muted-foreground font-default text-sm leading-relaxed">
                    hello@connectedonline.nl
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}